// extracted by mini-css-extract-plugin
export var emailBlockLink = "_lp-0";